import { render, staticRenderFns } from "./repaymentPlan.vue?vue&type=template&id=5a084474&scoped=true&"
import script from "./repaymentPlan.vue?vue&type=script&lang=ts&"
export * from "./repaymentPlan.vue?vue&type=script&lang=ts&"
import style0 from "./repaymentPlan.vue?vue&type=style&index=0&id=5a084474&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a084474",
  null
  
)

export default component.exports